/* @flow */

import React from 'react';
import PropTypes from 'prop-types';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';
import ErrorPage from 'four-nets/errors/error-page';

import { CategoryStore } from 'four-nets/forum/forum';
import CategoryView from './category-view';

class CategoryLoader extends React.PureComponent {
    static contextTypes = {
        app: PropTypes.object,
        categoryStore: PropTypes.instanceOf(CategoryStore),
    };

    fetch = setData => {
        const { categoryStore } = this.context;
        const { slug } = this.props.match.params;

        return categoryStore.loadSlug({ slug }).then(category => setData({ categoryId: category.id }));
    };

    renderFetch = ({ error, loading, data }) => {
        const { categoryStore } = this.context;

        return (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>
                    <CategoryView category={categoryStore.data.get(data?.categoryId)} />
                </ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        return <FetchData serializerKey={__filename} fetch={this.fetch} render={this.renderFetch} />;
    }
}

export default CategoryLoader;
